import { h, Component } from "preact";
import { connect } from "preact-redux";
import { ON_MOBILE_DEVICE } from "../../../../config";

import { Button } from "semantic-ui-react";
import { logoutUser } from "../../../user";

import { signOut, loadGAuth } from "../../../../utils/google-auth";

const requestSignOut = notifyAuthChange => e => {
  e.preventDefault();
  signOut().then(notifyAuthChange);
};

class DeviceGoogleLogout extends Component {
  constructor(props) {
    loadGAuth();
    super(props);
    this.onGoogleSignOutMobile = this.onGoogleSignOutMobile.bind(this);
    this.onUserLogout = this.onUserLogout.bind(this);
  }

  onUserLogout() {
    this.props.logoutUser();
  }

  onGoogleSignOutMobile() {
    window.plugins.googleplus.logout(() => {
      this.props.logoutUser();
    });
  }

  render() {
    return ON_MOBILE_DEVICE() ? (
      <Button unelevated onClick={() => this.onGoogleSignOutMobile()}>
        Logout
      </Button>
    ) : (
      <Button onClick={requestSignOut(this.onUserLogout)} className="ui button">
        Logout
      </Button>
    );
  }
}

const mapDispatchToProps = { logoutUser };

export default connect(
  null,
  mapDispatchToProps
)(DeviceGoogleLogout);



// WEBPACK FOOTER //
// ./src/modules/menu/components/deviceGoogleLogout/DeviceGoogleLogout.js